// noinspection JSUnusedGlobalSymbols

/**
 * Generated from backend
 */
export const enum SpecialtyTypeBusiness {
  SAFEVALUE = 1, // MBE SafeValue
  WINE = 2, // WINE
  GROUPAGE = 3, // GROUPAGE
  PALLET = 4, // MBE Pallet
  SAFEVALUE_4BUSINESS = 5, // MBE SafeValue 4Business
  WINE_2 = 6, // WINE2.0
  SPIRITS = 8,
  WINE_ALL = 9,
  SPIRITS_ALL = 10,
  GROUPAGE_2 = 7 // GROUPAGE2.0
}
/**
 * Generated from backend
 */
export const enum CourierBusiness {
  MBE = 0, // MBE
  UPS = 1, // UPS
  FEDEX = 2, // FedEx
  TNT = 3, // TNT
  DHL = 4, // DHL
  SDA = 5, // SDA
  SGT = 6, // SGT
  NEXIVE = 7, // Nexive
  GLS = 8, // GLS
  FREE_POSITION = 9, // FREE_POSITION
  CORREOS_EXPRESS = 10, // Correos-Express
  SEUR = 11, // SEUR
  CHRONOPOST = 12, // Chronopost
  DPD = 13, // DPD
  IDS = 14, // IDS
  POST_AG = 15, // Post-AG
  DHL_PAKET = 16, // DHL-Paket
  TIPSA = 17, // TIPSA
  INPOST = 18, // InPost
  HP = 19, // HP
  OTHER = 99, // Other
  USPS = 20, // USPS
  GLS_MICROLOGISTIC = 22, // GLS-Micrologistic
  CTT = 23, // CTT-Express
  PALLETWAYS = 98, // Palletways
  INTIME = 21, // Intime
  LOGIN = 24, // LogIn
  GEL = 96 // Gel
}
/**
 * Generated from backend
 */
export const enum SurchargeExtraServiceBusiness {
  GENERIC_ITEM = 0, // Generic Item
  MBE_SAFEVALUE = 1, // MBE SafeValue
  MBE_SAFEVALUE_4BUSINESS = 300, // MBE SafeValue 4Business
  CASH_ON_DELIVERY = 2, // Cash on Delivery
  INSURANCE_COURIER = 3, // Insurance Courier
  ACKNOWLEDGMENT = 4, // Acknowledgment
  ADDRESS_CORRECTION = 5, // Address Correction
  CARBON_NEUTRAL = 6, // Carbon Neutral
  CUSTOM_DUTIES_1 = 7, // Custom Duties 1
  CUSTOM_DUTIES_2 = 8, // Custom Duties 2
  CUSTOM_DUTIES_3 = 9, // Custom Duties 3
  CUSTOM_DUTIES_4 = 10, // Custom Duties 4
  CUSTOM_DUTIES_5 = 11, // Custom Duties 5
  DEDICATED_CUSTOMER_SERVICE = 12, // Dedicated Customer Service
  DELIVERED_DUTY_PAID = 13, // Delivered Duty Paid
  DELIVERY_APPOINTMENT = 14, // Delivery Appointment
  DELIVERY_DIRECT = 15, // Delivery Direct
  DELIVERY_DOOR = 16, // Delivery Door
  DELIVERY_EVENING = 17, // Delivery Evening
  DELIVERY_MORNING = 18, // Delivery Morning
  DELIVERY_NEUTRAL = 19, // Delivery Neutral
  DELIVERY_PRIORITY = 20, // Delivery Priority
  DELIVERY_PRIVATE_HOME = 21, // Delivery Private Home
  DELIVERY_SATURDAY = 22, // Delivery Saturday
  DELIVERY_SCHEDULED = 23, // Delivery Scheduled
  DELIVERY_SCHEDULED_DAY = 24, // Delivery Scheduled Day
  DELIVERY_SECOND_ATTEMPT = 25, // Delivery Second Attempt
  DELIVERY_SECOND_ATTEMPT_APPOINTMENT = 26, // Delivery Second Attempt Appointment
  DIMENSIONAL_SURCHARGE_1 = 27, // Dimensional Surcharge 1
  DIMENSIONAL_SURCHARGE_2 = 28, // Dimensional Surcharge 2
  DIMENSIONAL_SURCHARGE_3 = 29, // Dimensional Surcharge 3
  DIMENSIONAL_SURCHARGE_4 = 30, // Dimensional Surcharge 4
  DIMENSIONAL_SURCHARGE_5 = 31, // Dimensional Surcharge 5
  DRY_ICE = 32, // Dry Ice
  EX_WORKS = 33, // Ex Works
  EXTENDED_LIABILITY = 34, // Extended Liability
  FRAGILE = 35, // Fragile
  FUEL_SURCHARGE = 36, // Fuel Surcharge
  HIGHWAY_TAX = 37, // Highway Tax
  IDENTITY_CHECK = 38, // Identity Check
  INSURANCE_COURIER_EXTENDED = 39, // Insurance Courier Extended
  INSURANCE_FULL = 40, // Insurance Full
  INSURANCE_GLOBAL_PACKAGE = 41, // Insurance Global Package
  INSURANCE_GLOBAL_SHIPMENT = 42, // Insurance Global Shipment
  INSURANCE_OTHER = 43, // Insurance Other
  INSURANCE_OTHER_1 = 44, // Insurance Other 1
  INSURANCE_OTHER_2 = 45, // Insurance Other 2
  INSURANCE_OTHER_3 = 46, // Insurance Other 3
  INSURANCE_OTHER_4 = 47, // Insurance Other 4
  INSURANCE_OTHER_5 = 48, // Insurance Other 5
  LIMITED_TRAFFIC_ZONE = 49, // Limited Traffic Zone
  MISSING_RECEIVER = 50, // Missing Receiver
  MISSING_SENDER = 51, // Missing Sender
  MULTIPACKAGE_MANAGEMENT = 52, // Multipackage Management
  NON_PALLETIZED = 53, // Non Palletized
  NON_STACKABLE = 54, // Non Stackable
  NOTICE_DELIVERY_E_MAIL_BEFORE = 55, // Notice Delivery e-Mail Before
  NOTICE_DELIVERY_E_MAIL_FORECAST = 56, // Notice Delivery e-Mail Forecast
  NOTICE_DELIVERY_SMS_BEFORE = 57, // Notice Delivery SMS Before
  NOTICE_DELIVERY_SMS_FORECAST = 58, // Notice Delivery SMS Forecast
  NOTICE_DELIVERY_TELEPHONE_BEFORE = 59, // Notice Delivery Telephone Before
  NOTICE_DELIVERY_TELEPHONE_FORECAST = 60, // Notice Delivery Telephone Forecast
  NOTICE_PICKUP_E_MAIL_BEFORE = 61, // Notice Pickup e-Mail Before
  NOTICE_PICKUP_E_MAIL_FORECAST = 62, // Notice Pickup e-Mail Forecast
  NOTICE_PICKUP_SMS_BEFORE = 63, // Notice Pickup SMS Before
  NOTICE_PICKUP_SMS_FORECAST = 64, // Notice Pickup SMS Forecast
  NOTICE_PICKUP_TELEPHONE_BEFORE = 65, // Notice Pickup Telephone Before
  NOTICE_PICKUP_TELEPHONE_FORECAST = 66, // Notice Pickup Telephone Forecast
  PACKAGING_1 = 67, // Packaging 1
  PACKAGING_2 = 68, // Packaging 2
  PACKAGING_3 = 69, // Packaging 3
  PACKAGING_4 = 70, // Packaging 4
  PACKAGING_5 = 71, // Packaging 5
  PICKUP_APPOINTMENT = 72, // Pickup Appointment
  PICKUP_DOOR = 73, // Pickup Door
  PICKUP_EVENING = 74, // Pickup Evening
  PICKUP_MORNING = 75, // Pickup Morning
  PICKUP_PRIVATE_HOME = 76, // Pickup Private Home
  PICKUP_SATURDAY = 77, // Pickup Saturday
  PICKUP_TELEPHONE_FUTURE_DAY = 78, // Pickup Telephone Future Day
  PICKUP_TELEPHONE_SAME_DAY = 79, // Pickup Telephone Same Day
  PICKUP_WEB_FUTURE_DAY = 80, // Pickup Web Future Day
  PICKUP_WEB_SAME_DAY = 81, // Pickup Web Same Day
  PRIORITY_BOARDING = 82, // Priority Boarding
  PROOF_OF_DELIVERY_DIGITAL = 83, // Proof of Delivery Digital
  PROOF_OF_DELIVERY_PAPER = 84, // Proof of Delivery Paper
  QUANTUMVIEW_NOTIFICATION = 85, // QuantumView Notification
  REMOTE_AREA_1 = 86, // Remote Area 1
  REMOTE_AREA_2 = 87, // Remote Area 2
  REMOTE_AREA_3 = 88, // Remote Area 3
  REMOTE_AREA_4 = 89, // Remote Area 4
  REMOTE_AREA_5 = 90, // Remote Area 5
  REMOTE_COUNTRY_1 = 91, // Remote Country 1
  REMOTE_COUNTRY_2 = 92, // Remote Country 2
  REMOTE_COUNTRY_3 = 93, // Remote Country 3
  RETURN_ELECTRONIC = 94, // Return Electronic
  RETURN_ONE_ATTEMPT = 95, // Return One Attempt
  RETURN_PRINT = 96, // Return Print
  RETURN_PRINT_AND_SEND = 97, // Return Print and Send
  RETURN_THREE_ATTEMPTS = 98, // Return Three Attempts
  SIGNATURE_REQUIRED = 99, // Signature Required
  SIGNATURE_REQUIRED_ADULT = 100, // Signature Required Adult
  SPECIAL_HANDLING = 101, // Special Handling
  STATIONARY_STORAGE = 102, // Stationary Storage
  STOCK = 103, // Stock
  SUPERMARKETS_AND_MMR = 104, // Supermarkets and MMR
  TEMPORARY_IMPORT_EXPORT = 105, // Temporary Import/Export
  THIRD_PARTY_SHIPMENT = 106, // Third Party Shipment
  UNPAID_CASH_ON_DELIVERY = 107, // Unpaid Cash on Delivery
  TYRES = 108, // Tyres
  ALCOHOLIC_BEVERAGES = 109, // Alcoholic Beverages
  DANGEROUS_GOODS = 110, // Dangerous Goods
  PEAK_SURCHARGE = 111, // Peak Surcharge
  DUMMY_VALUE = 112, // Dummy Value
  PICKUP_PRIORITY = 113, // Pickup Priority
  DELIVERY_DEPARTMENT = 114, // Delivery Department
  DELIVERY_GUARANTEE = 115, // Delivery Guarantee
  DELIVERY_1600 = 116, // Delivery 16
  DELIVERY_1200 = 117, // Delivery 12
  DELIVERY_1000 = 118, // Delivery 10
  DELIVERY_0800 = 119, // Delivery 08
  NOTICE_AMAZON = 120, // Notice Amazon
  INTERNATIONAL_SPECIAL_COMMODITIES = 121, // International Special Commodities
  SECURITY_FEE = 125, // Security Fee
  EMERGENCY_SITUATION = 126, // Emergency Situation
  DPD_ADVICE_DATA = 127, // DPD ADVICE DATA
  BREXIT = 299, // Brexit
  ACCEPTANCE_REFUSED = 175, // Acceptance Refused
  RETURN_DOCUMENT = 176, // Return of document
  TNT_SURCHARGE = 177, // TNT Surcharge
  CONTACT_SERVICE = 2022, // Contact Service
  EXCHANGESERVICE = 2023, // ExchangeService
  ADRESSEEONLY_SERVICE = 2024, // AdresseeOnly Service
  PICK_SHIP = 2025, // Pick & Ship
  PICK_RETURN = 2026, // Pick & Return
  ENTRY_FEE = 310, // Entry fee
  AMAZON_SERVICE = 180, // Amazon Service
  TAIL_LIFT_SENDER = 181, // Tail Lift Sender
  TAIL_LIFT_RECEIVER = 182, // Tail Lift Receiver
  PALLETWAYS_REMOTE_AREA = 183, // Palletways Remote Area
  CUSTOM_DUTIES_ADMINISTRATIVE_FEE = 184, // Custom Duties Administrative Fee
  ZONE_2_SURCHARGE = 186, // Zone 2 Surcharge
  ECO_RESPONSIBLE_PARTICIPATION = 187, // Eco-Responsible Participation
  WINE2_FUEL_SURCHARGE = 200, // Wine2 Fuel Surcharge
  WINE2_RESIDENTIAL_SURCHARGE = 201, // Wine2 Residential Surcharge
  WINE2_ADULT_SIGNATURE = 202, // Wine2 Adult Signature
  LARGE_PACKAGE_FEE = 301, // Large Package Fee
  DECLARED_VALUE = 302, // Declared Value
  RESIDENTIAL_SURCHARGE = 303, // Residential Surcharge
  INDIRECT_SIGNATURE = 304, // Indirect Signature
  THIRD_PART_INSURANCE = 305, // Third Party Insurance
  OVER_WEIGHT_PIECE = 306, // Over Weight Piece
  OVER_SIZED_PIECE = 307, // Over Sized Piece
  ADDITIONAL_HANDLING = 308, // Additional Handling
  DAS_SURCHARGE_RESIDENTIAL = 309, // DAS Surcharge - Res
  CERTIFIED_EMAIL = 310, // Certified Email
  RETURN_RECEIPT = 311, // Return Receipt
  RESIDENTIAL_DELIVERY = 312, // Residential Delivery
  HOME_DELIVERY_DATE_CERTAIN = 313, // Home Delivery Date Certain
  HOME_DELIVERY_EVENING = 314, // Home Delivery Evening
  HOME_DELIVERY_APPOINTMENT = 315, // Home Delivery Appointment
  DAS_SURCHARGE_HOME_DELIVERY = 316, // DAS Surcharge Home Delivery
  DAS_EXT_SURCHARGE_RESIDENTIAL = 317, // DAS Ext Surcharge Residential
  DAS_EXT_SURCHARGE_HOME_DELIVERY = 318, // DAS Ext Surcharge Home Delivery
  DAS_SURCHARGE_COM = 319, // DAS Surcharge COM
  DAS_EXT_SURCHARGE_COM = 320, // DAS Ext Surcharge COM
  DAS_EXT_SURCHARGE_INTRA_HI = 321, // DAS Ext Surcharge Intra HI
  DAS_SURCHARGE_AK = 322, // DAS Surcharge AK
  DAS_SURCHARGE_HI = 323, // DAS Surcharge HI
  INT_OUT_DAS_RESIDENTIAL = 324, // INT OUT DAS Residential
  INT_OUT_DAS_COMMERCIAL = 325, // INT OUT DAS Commercial
  DIRECT_SIGNATURE_REQUIRED = 326, // Direct Signature Required
  REMOTE_AREA = 327, // Remote Area
  EXTENDED_AREA = 328, // Extended Area
  SHIPMENT_VALUE_PROTECTION = 329, // Shipment Value Protection
  PACKAGING_AND_MATERIALS = 330, // Packaging Supplies
  DELIVERY_CONFIRMATION_W_SIG = 402, // Delivery Confirmation w Sig
  ELEVATED_RISK_SURCHARGE = 403, // Elevated Risk Surcharge
  RESTRICTED_DESTINATION_SURCHARGE = 404, // Restricted Destination Surcharge
  EXPORTER_VALIDATION_SURCHARGE = 405, // Exporter Validation Surcharge
  RESIDENTIAL_SURCHARGE_HOME_DELIVERY = 406, // Residential Surcharge – Home Delivery
  DAS_SURCHARGE_INTRA_HI = 407, // DAS Surcharge – Intra HI
  DELIVERY_CONFIRMATION = 408, // Delivery Confirmation
  NONSTANDARD_LONGERSIDE_GREATERTHAN_22 = 409, // Nonstandard (L > 22 in)
  NONSTANDARD_LONGERSIDE_GREATERTHAN_30 = 410, // Nonstandard (L > 30 in)
  NONSTANDARD_VOLUME_GREATERTHAN_2CU_FT = 411 // Nonstandard (V > 2 cu ft)
}
/**
 * Generated from backend
 */
export const enum GoodsTypeBusiness {
  GOODS = 1, // GOODS
  LUGGAGE = 2, // LUGGAGE
  WINE = 3, // WINE
  GROUPAGE = 4, // GROUPAGE
  ART = 5, // ART
  DOCUMENTS = 6, // DOCUMENTS
  PERSONAL_THINGS = 7, // PERSONAL_THINGS
  SPORT_EQUIPMENT = 8, // SPORT_EQUIPMENT
  ALCOHOL = 9, // ALCOHOL
  PERISHABLE_GOODS = 10, // PERISHABLE_GOODS
  FOOD = 11, // FOOD
  ANTIQUES = 12, // ANTIQUES
  ART_SAFEVALUE = 13, // ART_SAFEVALUE
  WATCHES_AND_JEWELLERY = 14, // WATCHES_AND_JEWELLERY
  DANGEROUS_GOODS_LQ = 15, // DANGEROUS_GOODS_LQ
  DANGEROUS_GOODS = 16, // DANGEROUS_GOODS
  MEDICINE = 17, // MEDICINE
  ISC_BIO = 18 // ISC_BIO
}
/**
 * Generated from backend
 */
export const enum MBEShipServiceBusiness {
  MBE_ECONOMY = 1, // MBE ECONOMY
  MBE_STANDARD = 2, // MBE STANDARD
  MBE_OVERNIGHT = 3, // MBE OVERNIGHT
  MBE_EXPRESS = 4, // MBE EXPRESS
  MBE_MORNING = 5, // MBE MORNING
  MBE_EARLY_MORNING = 6, // MBE EARLY MORNING
  MBE_PONY_EXPRESS = 7, // MBE PONY EXPRESS
  MBE_SPECIAL_SERVICES = 8, // MBE SPECIAL SERVICES
  MBE_HANGING_CLOTHES_LARGE = 9, // MBE HANGING CLOTHES LARGE
  MBE_HANGING_CLOTHES_SMALL = 10, // MBE HANGING CLOTHES SMALL
  MBE_ACCESS_POINT = 11, // MBE ACCESS POINT
  MBE_WINE = 12, // MBE Wine
  UPS_EXPEDITED = 20, // UPS Expedited
  UPS_EXPRESS_SAVER = 21, // UPS Express Saver
  UPS_EXPRESS = 22, // UPS Express
  UPS_NEXT_DAY_AIR_EARLY = 23, // UPS NEXT DAY AIR EARLY
  UPS_NEXT_DAY_AIR = 24, // UPS NEXT DAY AIR
  UPS_NEXT_DAY_AIR_SAVER = 23, // UPS NEXT DAY AIR SAVER
  UPS_2ND_DAY_AIR_AM = 26, // UPS 2ND DAY AIR AM
  UPS_2ND_DAY_AIR = 27, // UPS 2ND DAY AIR
  UPS_3DAY_SELECT = 28, // UPS 3DAY SELECT
  UPS_GROUND = 29, // UPS GROUND
  UPS_STANDARD = 30, // UPS Standard
  GEL_PROXIMITY_POINT = 12
}
/**
 * Generated from backend
 */
export const enum MBEPackageTypeBusiness {
  MBE_ENVELOPE = 1, // MBE ENVELOPE
  MBE_DOCUMENTS = 2, // MBE DOCUMENTS
  MBE_PACKAGE = 3, // MBE PACKAGE
  MBE_PALLET = 4, // MBE PALLET
  MBE_REGISTERED_MAIL = 5, // MBE REGISTERED MAIL
  MBE_RETURN = 6, // MBE RETURN
  LETTER = 20, // LETTER
  OTHER = 21, // OTHER
  UPS_LETTER = 22, // UPS LETTER
  UPS_TUBE = 23, // UPS TUBE
  UPS_BOX_EXP_SMALL = 24, // UPS BOX EXP SMALL
  UPS_BOX_EXP_MEDIUM = 25, // UPS BOX EXP MEDIUM
  UPS_BOX_EXP_LARGE = 26, // UPS BOX EXP LARGE
  UPS_BOX_10_KG = 27, // UPS BOX 10 KG
  UPS_BOX_25_KG = 28, // UPS BOX 25 KG
  UPS_PAK = 29, // UPS PAK
  UPS_PAK_PAD = 30, // UPS PAK PAD
  UPS_PAK_EXP = 31, // UPS PAK EXP
  UPS_PAK_EXP_HARD = 32, // UPS PAK EXP HARD
  FEDEX_ENVELOPE = 33, // FEDEX ENVELOPE
  FEDEX_PAK = 34, // FEDEX PAK
  FEDEX_PADDED_PAK = 35, // FEDEX PADDED_PAK
  FEDEX_STURDY_PAK = 36, // FEDEX STURDY_PAK
  FEDEX_CLINICAL_PAK = 37, // FEDEX CLINICAL_PAK
  FEDEX_TUBE = 38, // FEDEX TUBE
  FEDEX_BOX = 39, // FEDEX BOX
  FEDEX_MEDIUM_BOX = 40, // FEDEX MEDIUM BOX
  FEDEX_LARGE_BOX = 41, // FEDEX LARGE BOX
  FEDEX_SMALL_BOX = 42, // FEDEX SMALL BOX
  FEDEX_10_KG_BOX = 43, // FEDEX 10 KG BOX
  FEDEX_EXTRA_LARGE_BOX = 44, // FEDEX EXTRA LARGE_BOX
  FEDEX_25_KG_BOX = 45, // FEDEX 25 KG BOX
  FEDEX_SLEEVE = 46, // FEDEX SLEEVE
  FEDEX_FREIGHT_LARGE_BOX = 47, // FEDEX FREIGHT LARGE BOX
  FEDEX_FREIGHT_SMALL_BOX = 48, // FEDEX FREIGHT SMALL BOX
  DHL_LETTER = 49, // DHL LETTER
  DHL_BOX_2_CUBE = 50, // DHL BOX 2 CUBE
  DHL_BOX_2_MEDIUM = 51, // DHL BOX 2 MEDIUM
  DHL_BOX_2_SMALL = 52, // DHL BOX 2 SMALL
  DHL_BOX_3_LARGE = 53, // DHL BOX 3 LARGE
  DHL_LARGE_PAK = 54, // DHL LARGE PAK
  DHL_LARGE_POUCH = 55, // DHL LARGE POUCH
  DHL_LARGE_TRI_TUBE = 56, // DHL LARGE TRI TUBE
  DHL_PAK = 57, // DHL Pak
  DHL_SMALL_PAK = 58, // DHL SMALL PAK
  DHL_SMALL_POUCH = 59, // DHL SMALL POUCH
  DHL_SMALL_TRI_TUBE = 60, // DHL SMALL TRI TUBE
  USPS_FLATR_ENV_EXP = 61, // USPS FLATR ENV EXP
  USPS_FLATR_ENV_LEGAL = 62, // USPS FLATR ENV LEGAL
  USPS_FLATR_ENV_EXP_LEGAL = 63, // USPS FLATR ENV EXP LEGAL
  USPS_FLATR_ENV_EXP_PADDED = 64, // USPS FLATR ENV EXP PADDED
  USPS_FLATR_ENV_PRI = 65, // USPS FLATR ENV PRI
  USPS_FLATR_GIFTCARD_ENV_PRI = 66, // USPS FLATR GIFTCARD ENV PRI
  USPS_FLATR_PADDED_ENV_PRI = 67, // USPS FLATR PADDED ENV PRI
  USPS_FLATR_SMALL_ENV_PRI = 68, // USPS FLATR SMALL ENV PRI
  USPS_FLATR_WINDOW_ENV_PRI = 69, // USPS FLATR WINDOW ENV PRI
  USPS_FLATR_BOX_MEDIUM = 70, // USPS FLATR BOX MEDIUM
  USPS_FLATR_BOX_SMALL = 71, // USPS FLATR BOX SMALL
  USPS_FLATR_BOX_LARGE = 72, // USPS FLATR BOX LARGE
  USPS_FLATR_BOX_MILITARY = 73, // USPS FLATR BOX MILITARY
  USPS_SOFT_PACK = 74, // USPS SOFT PACK
  USPS_TUBE = 75, // USPS TUBE
  USPS_EXP_BOX = 76, // USPS EXP BOX
  USPS_BOX_REGNLA1_PRI = 77, // USPS BOX REGNLA1 PRI
  USPS_BOX_REGNLA2_PRI = 78, // USPS BOX REGNLA2 PRI
  USPS_BOX_REGNLB1_PRI = 79, // USPS BOX REGNLB1 PRI
  USPS_BOX_REGNLB2_PRI = 80, // USPS BOX REGNLB2 PRI
  USPS_LETTER = 81, // USPS LETTER
  USPS_TUBE_LARGE = 82, // USPS TUBE LARGE
  USPS_PRI_BOX_O_1092 = 83, // USPS PRI BOX O 1092
  USPS_PRI_BOX_O_1095 = 84, // USPS PRI BOX O 1095
  USPS_PRI_BOX_O_1097 = 85, // USPS PRI BOX O 1097
  USPS_PRI_BOX_O_BOX4 = 86, // USPS PRI BOX O BOX4
  USPS_PRI_BOX_O_BOX7 = 87, // USPS PRI BOX O BOX7
  USPS_PRI_BOX_VIDEO_S = 88, // USPS PRI BOX VIDEO S
  USPS_PRI_BOX_VIDEO_L = 89, // USPS PRI BOX VIDEO L
  USPS_PRI_BOX_SHOE = 90, // USPS PRI BOX SHOE
  USPS_PRI_BOX_MEDIA = 91, // USPS PRI BOX MEDIA
  USPS_LARGE_ENVELOPES_FLATS = 92 // USPS LARGE ENVELOPES (FLATS)
}
/**
 * Generated from backend
 */
export const enum TenantListBusiness {
  ITALY = 1, // IT
  SPAIN = 2, // ES
  GERMANY = 3, // DE
  AUSTRIA = 4, // AT
  FRANCE = 5, // FR
  POLAND = 6, // PL
  PORTUGAL = 7, // PT
  SWITZERLAND = 8, // CH
  CROATIA = 9, // HR
  UNITEDSTATES = 10, // US
  CANADA = 11, // CA
  UK = 15 // UK
}
/**
 * Generated from backend
 */
export const enum ChronopostServiceBusiness {
  CH_18 = 2801, // Chrono18
  CH_13 = 2802, // Chrono13
  CH_10 = 2803, // Chrono10
  CH_R_13 = 2804, // ChronoRelais13
  CH_C = 2805, // ChronoClassic
  CH_C_R = 2806, // ChronoClassicRelais
  CH_E = 2807 // ChronoExpress
}
/**
 * Generated from backend
 */
export const enum CorreosServiceBusiness {
  PAQ_10 = 1901, // PAQ10
  PAQ_14 = 1902, // PAQ14
  PAQ_24 = 1904, // PAQ24
  PAQ_24_EC = 1912, // PAQ24_EC
  ENTREGAPLUS_ENTREGA_RECOGIDA = 1906, // EntregaPlus + ENTREGA + RECOGIDA
  ENTREGAPLUS_ENTREGA_RECOGIDA_MANIPULACION = 1906, // EntregaPlus ENTREGA +RECOGIDA + MANIPULACION
  PAQ_EMPRESA_14 = 1903 // PAQE14
}
/**
 * Generated from backend
 */
export const enum CTTServiceBusiness {
  CTT_ECONOMY = 2501, // CTT_ECONOMY
  CTT_EXPRESS = 2502, // CTT_EXPRESS
  CTT_MORNING = 2503, // CTT_MORNING
  CTT_EARLY_MORNING = 2504, // CTT_EARLY_MORNING
  CTT_STANDARD = 2505, // CTT_STANDARD
  CTT_EXPRESS_BAL = 2506 // CTT_EXPRESS_BAL
}
/**
 * Generated from backend
 */
export const enum DHLPaketServiceBusiness {
  DHL_PAKET = 2601, // DHL Paket
  DHL_PAKET_TAGGLEICH = 2602, // DHL paket taggleich
  DHL_PAKET_INTERNATIONAL = 2603, // DHL paket international
  DHL_PAKET_EUROPAKET = 2604, // DHL europaket
  DHL_PAKET_CONNETCT = 2605, // DHL paket connect
  DHL_PAKET_AUSTRIA = 2606, // DHL v86 parcel
  DHL_PAKET_AUTRIA_CONNECT = 2607, // DHL paket connect
  DHL_PAKET_AUSTRIA_INTERNATIONAL = 2608 // DHL paket austria international
}
/**
 * Generated from backend
 */
export const enum DHLPlServiceBusiness {
  DHL_PL_AH = 1300, // Standard domestic shipment
  DHL_PL_09 = 1303, // Domestic 09
  DHL_PL_12 = 1304, // Domestic 12
  DHL_PL_PR = 1302, // Domestic product premium
  DHL_PL_EK = 1301, // Domestic connect
  DHL_PL_MAX = 1305, // Domestic pallet shipment
  DHL_PL_PI = 1306, // International shipment
  DHL_PL_PC = 1307 // Conect shipment
}
/**
 * Generated from backend
 */
export const enum UPSServiceBusiness {
  UPS_STANDARD = 1001, // UPS STANDARD
  UPS_EXPEDITED = 1002, // UPS EXPEDITED
  UPS_EXPRESS_SAVER = 1003, // UPS EXPRESS SAVER
  UPS_EXPRESS = 1004, // UPS EXPRESS
  UPS_EXPRESS_PLUS = 1005, // UPS EXPRESS PLUS
  UPS_EXPRESS_FREIGHT = 1006, // UPS EXPRESS FREIGHT
  UPS_EXPRESS_12 = 1007, // UPS EXPRESS 12
  UPS_EXPRESS_FREIGHT_MIDDAY = 1008, // UPS EXPRESS FREIGHT MIDDAY
  UPS_TODAY_STANDARD = 1009, // UPS TODAY STANDARD
  UPS_TODAY_EXPRESS_SAVER = 1010, // UPS TODAY EXPRESS SAVER
  UPS_TODAY_EXPRESS = 1011, // UPS TODAY EXPRESS
  UPS_EXPRESS_SAVER_DUMMY = 1053, // UPS EXPRESS SAVER
  UPS_NEXT_DAY_AIR_EARLY = 1012, // UPS NEXT DAY AIR EARLY
  UPS_NEXT_DAY_AIR = 1013, // UPS NEXT DAY AIR
  UPS_NEXT_DAY_AIR_SAVER = 1014, // UPS NEXT DAY AIR SAVER
  UPS_2ND_DAY_AIR_AM = 1015, // UPS 2ND DAY AIR AM
  UPS_2ND_DAY_AIR = 1016, // UPS 2ND DAY AIR
  UPS_3DAY_SELECT = 1017, // UPS 3DAY SELECT
  UPS_GROUND = 1018, // UPS GROUND
  UPS_ACCESS_POINT = 1019, // UPS ACCESS POINT
  UPS_GROUND_STANDARD = 1020, // UPS GROUND_STANDARD
  UPS_GROUND_EXPRESS = 1021, // UPS GROUND_EXPRESS
  UPS_WINE2_GROUND_STANDARD = 1060, // UPS WINE2 GROUND STANDARD
  UPS_WINE2_GROUND_EXPRESS = 1061 // UPS WINE2 GROUND EXPRESS
}
/**
 * Generated from backend
 */
export const enum TNTServiceBusiness {
  TNT_ECONOMY_EXPRESS = 1201, // TNT ECONOMY EXPRESS
  TNT_EXPRESS = 1202, // TNT EXPRESS
  TNT_EXPRESS_12 = 1203, // TNT EXPRESS 12
  TNT_EXPRESS_10 = 1204, // TNT EXPRESS 10
  TNT_EXPRESS_09 = 1205, // TNT EXPRESS 09
  TNT_EXPRESS_08 = 1206, // TNT EXPRESS 08
  TNT_EXPRESS_ECONOMY = 1207, // TNT EXPRESS ECONOMY
  TNT_EXPRESS_PLUS = 1208, // TNT EXPRESS PLUS
  TNT_EXPRESS_DUMMY = 1252, // TNT EXPRESS
  TNT_EXPRESS_12_DUMMY = 1253, // TNT EXPRESS 12
  TNT_IT_ECONOMY_EXPRESS = 7101, // TNT IT ECONOMY EXPRESS
  TNT_IT_EXPRESS = 7102, // TNT IT EXPRESS
  TNT_IT_EXPRESS_12 = 7103, // TNT IT EXPRESS 12
  TNT_IT_EXPRESS_10 = 7104, // TNT IT EXPRESS 10
  TNT_IT_EXPRESS_09 = 7105, // TNT IT EXPRESS 09
  TNT_IT_BAULETTI_GRANDI = 7106, // TNT IT BAULETTI GRANDI
  TNT_IT_BAULETTI_PICCOLI = 7107, // TNT IT BAULETTI PICCOLI
  TNT_FR_ECONOMY_EXPRESS = 7201, // TNT FR ECONOMY EXPRESS
  TNT_FR_EXPRESS = 7202, // TNT FR EXPRESS
  TNT_FR_EXPRESS_P = 7203, // TNT FR EXPRESS P
  TNT_FR_EXPRESS_12 = 7204, // TNT FR EXPRESS 12
  TNT_FR_EXPRESS_10 = 7205, // TNT FR EXPRESS 10
  TNT_FR_EXPRESS_09 = 7206, // TNT FR EXPRESS 09
  TNT_FR_EXPRESS_08 = 7207 // TNT FR EXPRESS 08
}
/**
 * Generated from backend
 */
export const enum SGTServiceBusiness {
  SGT_EXPE = 1501, // SGT EXPE
  SGT_EXPE_10 = 1502 // EXPE - ORE 10:00
}
/**
 * Generated from backend
 */
export const enum SDAServiceBusiness {
  SDA_EXTRALARGE = 1401, // SDA EXTRALARGE
  SDA_EXTRALARGE_T12 = 1402, // SDA EXTRALARGE 12
  SDA_EXTRALARGE_T10 = 1403, // SDA EXTRALARGE 10
  SDA_EXTRALARGE_T09 = 1404, // SDA EXTRALARGE 09
  SDA_GOLDEN = 1405, // SDA GOLDEN
  SDA_RACCOMANDATA = 1406, // SDA RACCOMANDATA
  SDA_RACCOMANDATA_1 = 1407, // SDA RACCOMANDATA 1
  SDA_RACCOMANDATA_1_T12 = 1408, // SDA RACCOMANDATA 1 12
  SDA_RACCOMANDATA_1_T10 = 1409, // SDA RACCOMANDATA 1 10
  SDA_RACCOMANDATA_1_T09 = 1410, // SDA RACCOMANDATA 1 09
  SDA_ANDATA_E_RITORNO = 1411, // SDA ANDATA E RITORNO
  SDA_ANDATA_E_RITORNO_T12 = 1412, // SDA ANDATA E RITORNO 12
  SDA_ANDATA_E_RITORNO_T10 = 1413, // SDA ANDATA E RITORNO 10
  SDA_ANDATA_E_RITORNO_T09 = 1414, // SDA ANDATA E RITORNO 09
  SDA_CAPI_APPESI_LARGE = 1415, // SDA CAPI APPESI LARGE
  SDA_CAPI_APPESI_SMALL = 1416, // SDA CAPI APPESI SMALL
  SDA_CRONO_INTERNAZIONALE = 1417, // CRONO INTERNAZIONALE
  SDA_ECONOMY = 1418 // SDA ECONOMY
}
/**
 * Generated from backend
 */
export const enum SeurServiceBusiness {
  SEUR_SERVICE = 2001 // SEUR SERVICE
}
/**
 * Generated from backend
 */
export const enum PostAtServiceBusiness {
  EMS = 2401, // EMS
  EMS_10 = 2402, // EMS10
  PAKET_OSTERREICH = 2403, // PAKET_OSTERREICH
  PREMIUM_LIGHT = 2404 // PREMIUM_LIGHT
}
/**
 * Generated from backend
 */
export const enum OtherServiceBusiness {
  OTHER_ECONOMY = 9901, // OTHER ECONOMY
  OTHER_STANDARD = 9902, // OTHER STANDARD
  OTHER_OVERNIGHT = 9903, // OTHER OVERNIGHT
  OTHER_EXPRESS = 9904, // OTHER EXPRESS
  OTHER_MORNING = 9905, // OTHER MORNING
  OTHER_EARLY_MORNING = 9906, // OTHER EARLY MORNING
  OTHER_PONY_EXPRESS = 9907, // OTHER PONY EXPRESS
  OTHER_SPECIAL_SERVICES = 9908 // OTHER SPECIAL SERVICES
}
/**
 * Generated from backend
 */
export const enum NexiveServiceBusiness {
  NEXIVE_SISTEMA_ESPRESSO = 1601, // NEXIVE SISTEMA ESPRESSO
  NEXIVE_SISTEMA_ECONOMY = 1602, // NEXIVE SISTEMA ECONOMY
  NEXIVE_SISTEMA_COMPLETO = 1603, // NEXIVE SISTEMA COMPLETO
  NEXIVE_SISTEMA_SLIM = 1604 // NEXIVE SISTEMA SLIM
}
/**
 * Generated from backend
 */
export const enum InPostServiceBusiness {
  INPOST_COURIER_STANDARD = 2701, // inpost_courier_standard
  INPOST_COURIER_EXPRESS_1000 = 2702, // inpost_courier_express_1000
  INPOST_COURIER_EXPRESS_1200 = 2703, // inpost_courier_express_1200
  INPOST_COURIER_EXPRESS_1700 = 2704, // inpost_courier_express_1700
  INPOST_COURIER_PALETTE = 2705, // inpost_courier_palette
  INPOST_COURIER_LOCAL_STANDARD = 2706, // inpost_courier_local_standard
  INPOST_COURIER_LOCAL_EXPRESS = 2707, // inpost_courier_local_express
  INPOST_COURIER_LOCAL_SUPER_EXPRESS = 2708 // inpost_courier_local_super_express
}
/**
 * Generated from backend
 */
export const enum IDSServiceBusiness {
  IDS_STANDARD = 2301 // STANDARD
}
/**
 * Generated from backend
 */
export const enum HPServiceBusiness {
  PALLETIZED_SHIPMENT = 1801, // Palletized shipment
  PACKAGE_24_J_1_ECONOMY = 1801, // Package 24 J+1 Economy
  PACKAGE_24_J_1_EXPRESS = 1802 // Package 24 J+1 Express
}
/**
 * Generated from backend
 */
export const enum GLSServiceBusiness {
  LIGHT_EXPRESS = 1701, // LIGHT EXPRESS
  LIGHT_EXPRESS_12 = 1702, // LIGHT EXPRESS 12
  EXPRESS = 1703, // EXPRESS
  EXPRESS_12 = 1704, // EXPRESS 12
  PUDO_LIGHT_EXPRESS = 1706, // PUDO LIGHT EXPRESS
  PUDO_EXPRESS = 1707 // PUDO EXPRESS
}
/**
 * Generated from backend
 */
export const enum FedExServiceBusiness {
  FEDEX_ECONOMY = 1101, // FEDEX ECONOMY
  FEDEX_INTERNATIONAL_PRIORITY = 1102, // FEDEX INTERNATIONAL PRIORITY
  FEDEX_ECONOMY_FREIGHT = 1103, // FEDEX ECONOMY FREIGHT
  FEDEX_PRIORITY_FREIGHT = 1104, // FEDEX PRIORITY FREIGHT
  FEDEX_FIRST_OVERNIGHT = 1105, // FEDEX FIRST OVERNIGHT
  FEDEX_2DAY_ECONOMY = 1106, // FEDEX 2DAY ECONOMY
  FEDEX_EXPRESS_SAVER = 1107, // FEDEX EXPRESS SAVER
  FEDEX_FREIGHT_1DAY = 1108, // FEDEX FREIGHT 1DAY
  FEDEX_FREIGHT_2DAY = 1109, // FEDEX FREIGHT 2DAY
  FEDEX_FREIGHT_3DAY = 1110, // FEDEX FREIGHT 3DAY
  FEDEX_GROUND = 1111, // FEDEX GROUND
  FEDEX_INTERNATIONAL_FIRST_OVERNIGHT = 1112, // FEDEX INTERNATIONAL FIRST OVERNIGHT
  FEDEX_PRIORITY_OVERNIGHT = 1113, // FEDEX PRIORITY OVERNIGHT
  FEDEX_STANDARD_OVERNIGHT = 1114, // FEDEX STANDARD OVERNIGHT
  FEDEX_CANADA_SVC = 1115, // FEDEX CANADA SVC
  FEDEX_HOME_DELIVERY = 1116, // FEDEX EXPRESS SAVER
  FEDEX_2DAY = 1117, // FEDEX EXPRESS SAVER
  FEDEX_INTERNATIONAL_PRIORITY_EXPRESS = 1118, // FEDEX INTERNATIONAL PRIORITY EXPRESS
  FEDEX_PL_STANDARD_STORE = 7301, // FEDEX PL STANDARD STORE
  FEDEX_PL_EXPRESS_12_STORE = 7302, // FEDEX PL EXPRESS 12 STORE
  FEDEX_PL_EXPRESS_10_STORE = 7303, // FEDEX PL EXPRESS 10 STORE
  FEDEX_PL_EXPRESS_09_STORE = 7304, // FEDEX PL EXPRESS 09 STORE
  FEDEX_PL_STANDARD_NOT_STORE = 7305, // FEDEX PL STANDARD NOT STORE
  FEDEX_PL_EXPRESS_12_NOT_STORE = 7306, // FEDEX PL EXPRESS 12 NOT STORE
  FEDEX_PL_EXPRESS_10_NOT_STORE = 7307, // FEDEX PL EXPRESS 10 NOT STORE
  FEDEX_PL_EXPRESS_09_NOT_STORE = 7308, // FEDEX PL EXPRESS 09 NOT STORE
  FEDEX_WINE2_GROUND_STANDARD = 1120, // FEDEX GROUND STANDARD FOR WINE
  FEDEX_WINE2_GROUND_EXPRESS = 1121 // FEDEX GROUND EXPRESS FOR WINE
}
/**
 * Generated from backend
 */
export const enum DPDServiceBusiness {
  DPD_CLASSIC = 2201, // DPD CLASSIC
  DPD_EXPRESS = 2202, // DPD EXPRESS
  DPD_EXPRESS_12 = 2203, // DPD EXPRESS 12
  DPD_EXPRESS_10 = 2204, // DPD EXPRESS 10
  DPD_EXPRESS_0830 = 2205, // DPD EXPRESS 08:30
  DPD_CLASSIC_SHOP = 2206, // DPD CLASSIC SHOP
  DPD_CLASSIC_DUMMY = 2251, // DPD CLASSIC
  DPD_CLASSIC_SHOP_DUMMY = 2256, // DPD CLASSIC SHOP
  DPD_AT_STANDARD = 7401, // DPD_Standard
  DPD_AT_PRIMETIME_1700 = 7402, // DPD AT PRIMETIME 1700
  DPD_AT_PRIMETIME_1200 = 7403, // DPD AT PRIMETIME 1200
  DPD_AT_PRIMETIME_1000 = 7404, // DPD AT PRIMETIME 1000
  DPD_AT_PRIMETIME_0900 = 7405, // DPD AT PRIMETIME 0900
  DPD_AT_PRIMETIME_SAT1200 = 7406, // DPD AT PRIMETIME SAT1200
  DPD_AT_PRIMETIME_SAT1000 = 7407, // DPD AT PRIMETIME SAT1200
  DPD_AT_PRIMETIME_SAT0900 = 7408, // DPD AT PRIMETIME SAT0900
  DPD_AT_PRIMETIME_TIMEFRAME = 7409, // DPD AT PRIMETIME TIMEFRAME
  DPD_AT_BTIMEFIXED = 7410, // DPD AT TIMEFIXED
  DPD_AT_WINE = 7411, // DPD AT WINE
  DPD_PL_CLASSIC = 7501, // DPD PL CLASSIC
  DPD_PL_EXPRESS = 7502, // DPD PL EXPRESS
  DPD_PL_EXPRESS_12 = 7503, // DPD PL EXPRESS 12
  DPD_PL_EXPRESS_0930 = 7504, // DPD PL EXPRESS 09:30
  DPD_PL_MAX = 7505 // DPD PL MAX
}
/**
 * Generated from backend
 */
export const enum DHLServiceBusiness {
  DHL_ECONOMY_SELECT = 1301, // DHL ECONOMY SELECT
  DHL_EXPRESS = 1302, // DHL EXPRESS
  DHL_EXPRESS_12 = 1303, // DHL EXPRESS 12
  DHL_EXPRESS_1030 = 1304, // DHL EXPRESS 10:30
  DHL_EXPRESS_09 = 1305, // DHL EXPRESS 09
  DHL_EXPRESS_DOM = 1306, // DHL EXPRESS DOM.
  DHL_EXPRESS_12_DOM = 1307, // DHL EXPRESS 12 DOM.
  DHL_EXPRESS_1030_DOM = 1308, // DHL EXPRESS 10:30 DOM.
  DHL_EXPRESS_09_DOM = 1309, // DHL EXPRESS 09 DOM.
  DHL_EXPRESS_WORLDWIDE = 1310 // DHL EXPRESS WORLDWIDE
}
/**
 * Generated from backend
 */
export const enum USPSServiceBusiness {
  USPS_FIRST_CLASS_MAIL = 2001, // USPS FIRST CLASS MAIL
  USPS_EXPRESS_MAIL = 2002, // USPS EXPRESS MAIL
  USPS_EXPRESS_MAIL_INTERNATIONAL = 2003, // USPS EXPRESS MAIL INTERNATIONAL
  USPS_PRIORITY_MAIL = 2004, // USPS PRIORITY MAIL
  USPS_MEDIA_MAIL = 2005, // USPS MEDIA MAIL
  USPS_FIRST_CLASS_MAIL_INTERNATIONAL = 2006, // USPS FIRST CLASS MAIL INTERNATIONAL
  USPS_PRIORITY_MAIL_INTERNATIONAL = 2007, // USPS PRIORITY MAIL INTERNATIONAL
  USPS_PARCEL_POST = 2008, // USPS PARCEL SELECT
  USPS_PARCEL_POST_MACHINABLE = 2009, // USPS PARCEL POST MACHINABLE
  USPS_MAIL_CUBIC_RATE = 2011, // USPS PARCEL POST MACHINABLE
  USPS_BOUND_PRINTED_MATTER = 2012, // USPS BOUND PRINTED MATTER
  USPS_FIRST_CLASS_LETTER = 2013, // USPS FIRST CLASS LETTER
  USPS_PRIORITY_EXPRESS = 2014, // USPS PRIORITY EXPRESS
  USPS_RETAIL_GROUND = 2015 // USPS RETAIL GROUND
}
/**
 * Generated from backend
 */
export const enum ContentFormatType {
  GIF = "GIF", // GIF
  PDF = "PDF", // PDF
  HTML = "HTML", // HTML
  PNG = "PNG", // PNG
  JPG = "JPG", // JPG
  JPEG = "JPEG", // JPEG
  JPE = "JPE", // JPE
  JFIF = "JFIF", // JFIF
  DOC = "DOC", // DOC
  DOCX = "DOCX", // DOCX
  DOCM = "DOCM", // DOCM
  DOTX = "DOTX", // DOTX
  DOTM = "DOTM", // DOTM
  XLS = "XLS", // XLS
  XLSX = "XLSX", // XLSX
  XLSM = "XLSM", // XLSM
  XLTX = "XLTX", // XLTX
  XLTM = "XLTM", // XLTM
  XLSB = "XLSB", // XLSB
  XLAM = "XLAM", // XLAM
  BMP = "BMP", // BMP
  TEC = "TEC", // TEC
  ZPL = "ZPL", // ZPL
  TXT = "TXT", // TXT
  TIF = "TIF", // TIF
  TIFF = "TIFF", // TIFF
  EPL = "EPL", // EPL
  PD1 = "PD1", // PD1
  XML = "XML", // XML
  RTF = "RTF", // RTF
  PLAINTEXT = "PLAIN TEXT" // PLAIN TEXT
}
/**
 * Generated from backend
 */
export const enum ChronopostPackageTypeBusiness {
  CH_ENVELOPE = 2801, // Chronopost ENVELOPE
  CH_DOCUMENTS = 2802, // Chronopost DOCUMENTS
  CH_PACKAGE = 2803 // Chronopost PACKAGE
}
/**
 * Generated from backend
 */
export const enum NexivePackageTypeBusiness {
  NEXIVE_ENVELOPE = 1601, // NEXIVE ENVELOPE
  NEXIVE_DOCUMENTS = 1602, // NEXIVE DOCUMENTS
  NEXIVE_PACKAGE = 1603, // NEXIVE PACKAGE
  NEXIVE_PALLET = 1604 // NEXIVE PALLET
}
/**
 * Generated from backend
 */
export const enum PalletwaysPackageTypeBusiness {
  PALLETWAYS_PALLET = 9804 // PALLETWAYS PALLET
}
/**
 * Generated from backend
 */
export const enum OtherPackageTypeBusiness {
  OTHER_ENVELOPE = 9901, // OTHER ENVELOPE
  OTHER_DOCUMENTS = 9902, // OTHER DOCUMENTS
  OTHER_PACKAGE = 9903, // OTHER PACKAGE
  OTHER_PALLET = 9904 // OTHER PALLET
}
/**
 * Generated from backend
 */
export const enum SDAPackageTypeBusiness {
  SDA_ENVELOPE = 1401, // SDA ENVELOPE
  SDA_DOCUMENTS = 1402, // SDA DOCUMENTS
  SDA_PACKAGE = 1403, // SDA PACKAGE
  SDA_PALLET = 1404, // SDA PALLET
  SDA_REGISTERED_MAIL = 1405, // SDA REGISTERED MAIL
  SDA_RETURN = 1406, // SDA RETURN
  SDA_HANGING_CLOTHES_LARGE = 1407, // SDA HANGING CLOTHES LARGE
  SDA_HANGING_CLOTHES_SMALL = 1408 // SDA HANGING CLOTHES SMALL
}
/**
 * Generated from backend
 */
export const enum SGTPackageTypeBusiness {
  SGT_ENVELOPE = 1501, // SGT ENVELOPE
  SGT_DOCUMENTS = 1502, // SGT DOCUMENTS
  SGT_PACKAGE = 1503, // SGT PACKAGE
  SGT_PALLET = 1504 // SGT PALLET
}
/**
 * Generated from backend
 */
export const enum TNTPackageTypeBusiness {
  TNT_ENVELOPE = 1201, // TNT ENVELOPE
  TNT_DOCUMENTS = 1202, // TNT DOCUMENTS
  TNT_PACKAGE = 1203, // TNT PACKAGE
  TNT_PALLET = 1204, // TNT PALLET
  TNT_HANGING_CLOTHES_LARGE = 1207, // TNT HANGING CLOTHES LARGE
  TNT_HANGING_CLOTHES_SMALL = 1208 // TNT HANGING CLOTHES SMALL
}
/**
 * Generated from backend
 */
export const enum UPSPackageTypeBusiness {
  UPS_ENVELOPE = 1001, // UPS ENVELOPE
  UPS_DOCUMENTS = 1002, // UPS DOCUMENTS
  UPS_PACKAGE = 1003, // UPS PACKAGE
  UPS_PALLET = 1004, // UPS PALLET
  LETTER = 1005, // UPS LETTER
  OTHER = 1006, // OTHER
  UPS_LETTER = 1007, // UPS LETTER
  UPS_TUBE = 1008, // UPS TUBE
  UPS_BOX_EXP_SMALL = 1009, // UPS BOX EXP SMALL
  UPS_BOX_EXP_MEDIUM = 1010, // UPS BOX EXP MEDIUM
  UPS_BOX_EXP_LARGE = 1011, // UPS LARGE
  UPS_BOX_10KG = 1012, // UPS BOX 10KG
  UPS_BOX_25KG = 1013, // UPS BOX 25KG
  UPS_PAK = 1014, // UPS PAK
  UPS_PAK_PAD = 1015, // UPS PAK PAD
  UPS_PAK_EXP = 10016, // UPS PAK EXP
  UPS_PAK_EXP_HARD = 10017 // UPS PAK EXP HARD
}
/**
 * Generated from backend
 */
export const enum USPSPackageTypeBusiness {
  LETTER = 2001, // USPS LETTER
  OTHER = 2002, // USPS OTHER
  USPS_FLATR_ENV_EXP = 2003, // USPS FLATR ENV EXP
  USPS_FLATR_ENV_LEGAL = 2004, // USPS FLATR ENV LEGAL
  USPS_FLATR_ENV_EXP_LEGAL = 2005, // USPS FLATR ENV EXP LEGAL
  USPS_FLATR_ENV_EXP_PADDED = 2006, // USPS FLATR ENV EXP PADDED
  USPS_FLATR_ENV_PRI = 2007, // USPS FLATR ENV PRI
  USPS_FLATR_GIFTCARD_ENV_PRI = 2008, // USPS FLATR GIFTCARD ENV PRI
  USPS_FLATR_PADDED_ENV_PRI = 2009, // USPS FLATR PADDED ENV PRI
  USPS_FLATR_SMALL_ENV_PRI = 2010, // USPS FLATR SMALL ENV PRI
  USPS_FLATR_WINDOW_ENV_PRI = 2011, // USPS FLATR WINDOW ENV PRI
  USPS_FLATR_BOX_MEDIUM = 2012, // USPS FLATR BOX MEDIUM
  USPS_FLATR_BOX_SMALL = 2013, // USPS FLATR BOX SMALL
  USPS_FLATR_BOX_LARGE = 2014, // USPS FLATR BOX LARGE
  USPS_FLATR_BOX_MILITARY = 2015, // USPS FLATR BOX MILITARY
  USPS_SOFT_PACK = 2016, // USPS SOFT PACK
  USPS_TUBE = 2017, // USPS TUBE
  USPS_EXP_BOX = 2018, // USPS EXP BOX
  USPS_EXP_BOX_REGNLA1_PRI = 2019, // USPS EXP BOX REGNLA1 PRI
  USPS_EXP_BOX_REGNLA2_PRI = 2020, // USPS EXP BOX REGNLA2 PRI
  USPS_EXP_BOX_REGNLB1_PRI = 2021, // USPS EXP BOX REGNLB1 PRI
  USPS_EXP_BOX_REGNLB2_PRI = 2022, // USPS EXP BOX REGNLB2 PRI
  USPS_LETTER = 2023, // USPS LETTER
  USPS_TUBE_LARGE = 2024, // USPS TUBE LARGE
  USPS_PRI_BOX_0_1092 = 2025, // USPS PRI BOX 0-1092
  USPS_PRI_BOX_0_1095 = 2026, // USPS PRI BOX 0-1095
  USPS_PRI_BOX_0_1097 = 2027, // USPS PRI BOX 0-1097
  USPS_PRI_BOX_O_BOX4 = 2028, // USPS PRI BOX O-BOX4
  USPS_PRI_BOX_O_BOX7 = 2029, // USPS PRI BOX O-BOX7
  USPS_PRI_BOX_VIDEO_S = 2030, // USPS PRI BOX VIDEO S
  USPS_PRI_BOX_BOX_VIDEO_L = 2031, // USPS PRI BOX BOX VIDEO L
  USPS_PRI_BOX_BOX_SHOE = 2032, // USPS PRI BOX BOX SHOE
  USPS_PRI_BOX_BOX_MEDIA = 2033, // USPS PRI BOX BOX MEDIA
  USPS_PARCEL = 2034 // USPS PARCEL
}
/**
 * Generated from backend
 */
export const enum ShipmentStatusType {
  DRAFT_NO_WAYBILL = "DRAFT_NO_WAYBILL", // DRAFT_NO_WAYBILL
  DRAFT_WAYBILL = "DRAFT_WAYBILL", // DRAFT_WAYBILL
  DRAFT_TO_BE_CLOSED = "DRAFT_TO_BE_CLOSED", // DRAFT_TO_BE_CLOSED
  CREATED = "CREATED", // CREATED
  IN_TRANSIT = "IN_TRANSIT", // IN_TRANSIT
  INVOICED = "INVOICED", // INVOICED
  OFFER = "OFFER" // OFFER
}
/**
 * Generated from backend
 */
export const enum AuthRoleType {
  H2P_STORE_FRONT = "H2P_STORE_FRONT", // H2P_STORE_FRONT
  COUNTRY_ADMIN = "COUNTRY_ADMIN", // COUNTRY_ADMIN
  MULTISTORE_ADMIN = "MULTISTORE_ADMIN", // MULTISTORE_ADMIN
  MULTISTORE_USER = "MULTISTORE_USER", // MULTISTORE_USER
  STORE_ADMIN = "STORE_ADMIN", // STORE_ADMIN
  STORE_USER = "STORE_USER", // STORE_USER
  ONLINEMBE_USER = "ONLINEMBE_USER", // ONLINEMBE_USER
  PRINT_SPEAK = "PRINT_SPEAK", // PRINT_SPEAK
  H2P_SUPPLIER = "H2P_SUPPLIER", // H2P_SUPPLIER
  PRINT_SPEAK_SUPPLIER = "PRINT_SPEAK_SUPPLIER", // PRINT_SPEAK_SUPPLIER
  SUPERVISOR = "SUPERVISOR", //SUPERVISOR
  MBE_LAB_SUPPLIER = "MBE_LAB_SUPPLIER", // MBE_LAB_SUPPLIER
  MBE_LAB_USER = "MBE_LAB_USER", // MBE_LAB_USER
  WINE_IMPORTER = "WINE_IMPORTER" // WINE_IMPORTER
}
/**
 * Generated from backend
 */
export const enum ShipmentSourceTypeBusiness {
  SHIPMENT_FORM_1 = 1, // SHIPMENT_FORM_1
  OFFER = 2, // OFFER
  WAYBILL_PRINT_BY_MBEONLINE = 3, // WAYBILL_PRINT_BY_MBEONLINE
  WAYBILL_PRINT_BY_CUSTOMER = 3, // WAYBILL_PRINT_BY_CUSTOMER
  WAYBILL_PRINT_BY_STORE = 5, // WAYBILL_PRINT_BY_STORE
  WOO_COMMERCE_WAYBILL_PRINT_BY_MBEONLINE = 20, // WOO_COMMERCE_WAYBILL_PRINT_BY_MBEONLINE
  WOO_COMMERCE_WAYBILL_PRINT_BY_CUSTOMER = 20, // WOO_COMMERCE_WAYBILL_PRINT_BY_CUSTOMER
  WOO_COMMERCE_WAYBILL_PRINT_BY_STORE = 17, // WOO_COMMERCE_WAYBILL_PRINT_BY_STORE
  MAGENTO_WAYBILL_PRINT_BY_MBEONLINE = 21, // MAGENTO_WAYBILL_PRINT_BY_MBEONLINE
  MAGENTO_WAYBILL_PRINT_BY_CUSTOMER = 21, // MAGENTO_WAYBILL_PRINT_BY_CUSTOMER
  MAGENTO_WAYBILL_PRINT_BY_STORE = 19, // MAGENTO_WAYBILL_PRINT_BY_STORE
  PRESTASHOP_WAYBILL_PRINT_BY_MBEONLINE = 22, // PRESTASHOP_WAYBILL_PRINT_BY_MBEONLINE
  PRESTASHOP_WAYBILL_PRINT_BY_CUSTOMER = 22, // PRESTASHOP_WAYBILL_PRINT_BY_CUSTOMER
  PRESTASHOP_WAYBILL_PRINT_BY_STORE = 18, // PRESTASHOP_WAYBILL_PRINT_BY_STORE
  SHOPIFY_WAYBILL_PRINT_BY_MBEONLINE = 29, // SHOPIFY_WAYBILL_PRINT_BY_MBEONLINE
  SHOPIFY_WAYBILL_PRINT_BY_CUSTOMER = 29, // SHOPIFY_WAYBILL_PRINT_BY_CUSTOMER
  SHOPIFY_WAYBILL_PRINT_BY_STORE = 30, // SHOPIFY_WAYBILL_PRINT_BY_STORE
  CLIENT_INTEGRATION_PRINT_BY_MBEONLINE = 6, // CLIENT_INTEGRATION_PRINT_BY_MBEONLINE
  CLIENT_INTEGRATION_PRINT_BY_CUSTOMER = 6, // CLIENT_INTEGRATION_PRINT_BY_CUSTOMER
  CLIENT_INTEGRATION_PRINT_BY_STORE = 4, // CLIENT_INTEGRATION_PRINT_BY_STORE
  ECOMMERCE_WAYBILL_PRINT_BY_MBEONLINE = 26, // ECOMMERCE_WAYBILL_PRINT_BY_MBEONLINE
  ECOMMERCE_WAYBILL_PRINT_BY_CUSTOMER = 26, // ECOMMERCE_WAYBILL_PRINT_BY_CUSTOMER
  ECOMMERCE_WAYBILL_PRINT_BY_STORE = 27, // ECOMMERCE_WAYBILL_PRINT_BY_STORE
  CSV_CONNECTOR = 15, // CSV_CONNECTOR
  CAMPUSSHIP = 7, // CAMPUSSHIP
  INTERNETSHIPPING = 8, // INTERNETSHIPPING
  MBE_ONLINE = 16, // MBE_ONLINE
  SHIPMENT_PACKAGE_EXCEL_IMPORT = 23, // SHIPMENT_PACKAGE_EXCEL_IMPORT
  SHIPMENT_EXCEL_IMPORT = 24, // SHIPMENT_EXCEL_IMPORT
  OTHER_IMPORT = 25, // OTHER_IMPORT
  QUANTUMVIEW = 9, // QUANTUMVIEW
  MBELAB = 19, // MBELAB
  EBAY_CONNECTOR = 14, // EBAY_CONNECTOR
  AMAZON_CONNECTOR = 26, // AMAZON_CONNECTOR
  INVOICECHECK = 28 // INVOICECHECK
}
/**
 * Generated from backend
 */
export const enum DocumentType {
  WAYBILL = "WAYBILL", // WAYBILL
  COD_TURN_IN = "COD_TURN_IN", // COD_TURN_IN
  PROTOCOL = "PROTOCOL", // PROTOCOL
  SENDER_COPY = "SENDER_COPY", // SENDER_COPY
  CASH_ON_DELIVERY = "CASH_ON_DELIVERY", // CASH_ON_DELIVERY
  PACKAGE_REFERENCE = "PACKAGE_REFERENCE", // PACKAGE_REFERENCE
  ELECTRONIC_RETURN_LABEL_RECEIPT = "ELECTRONIC_RETURN_LABEL_RECEIPT", // ELECTRONIC_RETURN_LABEL_RECEIPT
  CONNOTE = "CONNOTE", // CONNOTE
  SAFEVALUE = "SAFEVALUE", // SAFEVALUE
  ENDDAYFILE = "END_DAY_FILE", // END_DAY_FILE
  GENERIC = "GENERIC", // GENERIC
  RECEIPT = "RECEIPT", // RECEIPT
  PROFORMA = "PROFORMA", // PROFORMA
  COD = "COD", // COD
  ELECTRONIC_INVOICE = "ELECTRONIC_INVOICE", // ELECTRONIC_INVOICE
  OFFER_REPORT = "OFFER_REPORT", // OFFER_REPORT
  EXPORT = "EXPORT", // EXPORT
  PRICELIST_EXPORT = "PRICELIST_EXPORT", // PRICELIST_EXPORT
  PROOF_OF_DELIVERY = "PROOF_OF_DELIVERY", // PROOF_OF_DELIVERY
  SHIPMENT_PALLET_QUOTE_REQUEST = "SHIPMENT_PALLET_QUOTE_REQUEST", // SHIPMENT_PALLET_QUOTE_REQUEST
  MBE_WAYBILL = "MBE_WAYBILL", // MBE_WAYBILL
  MANIFEST = "MANIFEST", // MANIFEST
  STAMPS = "STAMPS", // STAMPS
  MAILBOX_PACKAGE_NOTICE = "MAILBOX_PACKAGE_NOTICE", // MAILBOX_PACKAGE_NOTICE
  MAILBOX_RENTAL_AGREEMENT = "MAILBOX_RENTAL_AGREEMENT", // MAILBOX_RENTAL_AGREEMENT
  REPORTS = "REPORTS", // REPORTS
  RECEIPT_SLIPS = "RECEIPT_SLIPS", // RECEIPT_SLIPS
  STATEMENT = "STATEMENT", // STATEMENT
  INVOICE = "INVOICE" // INVOICE
}
/**
 * Generated from backend
 */
export const enum IscGoodsType {
  ALCOHOLIC_BEVERAGES = "ALCOHOLIC_BEVERAGES", // ALCOHOLIC_BEVERAGES
  PERISHABLES = "PERISHABLES", // PERISHABLES
  PLANTS = "PLANTS", // PLANTS
  SEEDS = "SEEDS", // SEEDS
  SPECIAL_EXCEPTIONS = "SPECIAL_EXCEPTIONS", // SPECIAL_EXCEPTIONS
  TOBACCO = "TOBACCO", // TOBACCO
  DIAGNOSTIC_SPECIMENTS = "DIAGNOSTIC_SPECIMENTS" // DIAGNOSTIC_SPECIMENTS
}
/**
 * Generated from backend
 */
export const enum PrinterConfigurationFormatType {
  fA6 = "A6", // A6
  fA4 = "A4", // A4
  f11x12cm = "4.3x4.8", // 4.3x4.8
  f4x6 = "4x6", // 4x6
  f4x8 = "4x8", // 4x8
  f5x9 = "5x9", // 5x9
  f28x89 = "30252 Address", // 30252 Address
  f80x297 = "Roll Paper 80x297" // Roll Paper 80x297
}
